module.exports = __webpack_public_path__ + "static/media/photo_3.09db2535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_3.jpg
// module id = 1636
// module chunks = 0